import { internationalBeneficiaryFieldName } from '@routable/fund-routes';
export const individualIdFieldNameOptions = [
    {
        id: 1,
        label: 'CNIC (Computerized National Identity Card)',
        value: internationalBeneficiaryFieldName.Enum.pk_cnic,
    },
    { id: 2, label: 'Passport', value: internationalBeneficiaryFieldName.Enum.pk_pass },
    {
        id: 3,
        label: 'SNIC (Smart National Identity Card)',
        value: internationalBeneficiaryFieldName.Enum.pk_snic,
    },
];
